<script setup>
    const emits = defineEmits(['onChange'])
</script>

<template>
    <div class="file has-name is-fullwidth mb-3">
        <label class="file-label">
            <input ref="multipleImagesInput" class="file-input" type="file" accept="image/*" multiple @change="emits('onChange', $event)">
            <span class="file-cta">
                <span class="file-icon"><i class="mdi mdi-image-multiple"></i></span>
                <span class="file-label">{{ $t('file_upload.select_multiple_slides') }}...</span>
            </span>
            <span class="file-name">{{ $t('file_upload.select_files') }}</span>
        </label>
    </div>
</template>
